<script>
  export let data;
  import Profile from '@pages/Profile.svelte';
  import ProfileOpenGraph from '@og/Profile.svelte';

  let { og, user, groups, groupCollections, groupCollectionsSortOrder } = data;
  $: ({ og, user, groups, groupCollections, groupCollectionsSortOrder } = data);
</script>

{#key user.id}
  <ProfileOpenGraph user={og.user} />
  <Profile
    id={og.id}
    user={user}
    groups={groups}
    groupCollections={groupCollections}
    groupCollectionsSortOrder={groupCollectionsSortOrder} />
{/key}
